// extracted by mini-css-extract-plugin
export default {"panel":"SMLClicksChart_panel__3GdBF","chart":"SMLClicksChart_chart__hSXPX","empty":"SMLClicksChart_empty__YMf1y"};